import React from 'react';

// accounts: [{account_name, ...}]
// selected: string[] (빈 배열 = 전체)
export default function AccountChips({ accounts, selected, onSelect }) {
  const toggle = (name) => {
    if (onSelect) {
      if (name === '__all__') {
        onSelect([]);
      } else {
        const next = selected.includes(name)
          ? selected.filter(a => a !== name)
          : [...selected, name];
        onSelect(next);
      }
    }
  };

  const allActive = selected.length === 0;

  return (
    <div className="mb-chips-wrap">
      <button
        className={`mb-chip${allActive ? ' active' : ''}`}
        onClick={() => toggle('__all__')}
      >
        전체
      </button>
      {accounts.map(a => (
        <button
          key={a.account_name}
          className={`mb-chip${selected.includes(a.account_name) ? ' active' : ''}`}
          onClick={() => toggle(a.account_name)}
        >
          {a.account_name}
        </button>
      ))}
    </div>
  );
}
